let gameFinished = false;

/*

ESPERAR AL POPUP

El popup se inyecta en el DOM despues de que este script
se cargue, asi que hay que esperar a que aparezcan las
cartas antes de inicializar el juego.
*/

function waitForPopup() {

    if (document.querySelector(".vl-card")) {
        initGame();
        return;
    }

    const observer = new MutationObserver(() => {

        if (document.querySelector(".vl-card")) {
            observer.disconnect();
            initGame();
        }

    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

}

/*

JUEGO
*/

function initGame() {

    const cards = document.querySelectorAll(".vl-card");

    const messageTitle =
        document.getElementById("vl-messageTitle");

    const messageText =
        document.getElementById("vl-messageText");

    /*

    CARTAS


    Todas las cartas son ganadoras.
    */

    cards.forEach((card) => {

        card.addEventListener("click", () => {

            if (gameFinished) {
                return;
            }

            if (card.classList.contains("vl-flipped")) {
                return;
            }


            /*
             * Contenido de la carta ganadora
             */

            const cardFront =
                card.querySelector(".vl-card-front");

            cardFront.innerHTML = `
            <div class="vl-icon">🎁</div>
            <strong>¡Has ganado!</strong>
            <small>10% de descuento</small>
        `;


            /*
             * Girar carta
             */

            card.classList.add("vl-flipped");


            /*
             * Marcar como ganadora
             */

            gameFinished = true;

            card.classList.add("vl-winner");


            /*
             * Mostrar mensaje de premio
             */

            messageTitle.textContent =
                "🎉 ¡Enhorabuena!";

            messageText.textContent =
                "Has conseguido un 10% de descuento.";


            /*
             * Bloquear las demás cartas
             */

            cards.forEach(otherCard => {

                if (otherCard !== card) {
                    otherCard.classList.add("vl-disabled");
                }

            });


            /*
             * Mostrar confeti
             */

            createConfetti(card.closest(".vl-popup-inner"));


            /*
             * Avisar que el reto se ha completado
             */

            if (typeof window.retoCompletado === "function") {
                window.retoCompletado();
            }

        });

    });

}

waitForPopup();

/*

BOTÓN "VER CÓDIGO" -> PASO 2

window.retoCompletado() muestra el botón visible (#mi-boton-paso2)
cuando el reto termina. El clic sobre ese botón se delega en
document porque Klaviyo puede reconstruir el bloque HTML y
destruiría cualquier listener puesto directamente sobre el botón.

El botón real que avanza de paso es el nativo de Klaviyo
(.klaviyo-form-button-reto), oculto con CSS. Lo buscamos desde el
getRootNode() del botón visible por si el formulario vive en un
Shadow DOM, y subimos por los hosts si hiciera falta.
*/

window.retoCompletado = function retoCompletado() {

    const boton =
        document.getElementById("mi-boton-paso2");

    if (boton) {
        boton.classList.add("vl-visible");
    }

};

function buscarBotonNativoReto(elementoOrigen) {

    function buscarEnRaiz(raiz) {

        if (!raiz || typeof raiz.querySelector !== "function") {
            return null;
        }

        const el = raiz.querySelector(".klaviyo-form-button-reto");

        if (!el) {
            return null;
        }

        if (el.tagName === "BUTTON") {
            return el;
        }

        return el.querySelector("button") || el;

    }

    let raiz = elementoOrigen.getRootNode();
    let encontrado = buscarEnRaiz(raiz);

    while (!encontrado && raiz instanceof ShadowRoot) {
        raiz = raiz.host.getRootNode();
        encontrado = buscarEnRaiz(raiz);
    }

    return encontrado || buscarEnRaiz(document);

}

document.addEventListener("click", (e) => {

    const trigger = e.target.closest("#mi-boton-paso2");

    if (!trigger) {
        return;
    }

    e.preventDefault();

    const intentarClick = (intentosRestantes) => {

        const nativo = buscarBotonNativoReto(trigger);

        if (nativo) {
            nativo.click();
            return;
        }

        if (intentosRestantes > 0) {
            setTimeout(() => intentarClick(intentosRestantes - 1), 150);
        } else {
            console.warn(
                "[Reto] No se encontró el botón nativo .klaviyo-form-button-reto"
            );
        }

    };

    intentarClick(10);

});

/*

CONFETI
*/

function createConfetti(container) {

    /*
     * Klaviyo aplica el CSS del bloque "Custom HTML" con alcance
     * limitado a su propio contenedor. Si el confeti se añadiera a
     * document.body (fuera de ese contenedor) quedaría sin estilos:
     * se crea pero no se ve. Por eso se cuelga de .vl-popup-inner.
     * Al tener overflow:hidden y cubrir exactamente el viewport,
     * además evita que alguna pieza cerca del borde (left~100vw o
     * la caída hasta 110vh) dispare un scroll del documento.
     */
    const parent = container || document.body;

    const numberOfConfetti = 90;

    for (let i = 0; i < numberOfConfetti; i++) {

        const piece =
            document.createElement("div");

        piece.classList.add("vl-confetti");

        piece.style.left =
            Math.random() * 100 + "vw";

        piece.style.animationDuration =
            (2 + Math.random() * 3) + "s";

        piece.style.animationDelay =
            Math.random() * 1.5 + "s";

        piece.style.transform =
            `rotate(${Math.random() * 360}deg)`;


        /*
         * Colores del confeti
         */

        const colors = [
            "#ffd43b",
            "#ff8a00",
            "#ffffff",
            "#ff5c5c",
            "#5ce1ff"
        ];

        piece.style.background =
            colors[
            Math.floor(
                Math.random() * colors.length
            )
            ];


        parent.appendChild(piece);


        setTimeout(() => {
            piece.remove();
        }, 5500);

    }

}
